import Layout from './src/Layout';

// Core layout and modals
export default Layout;
export * from './src/components/MessageWithCloseButtonModal';
export * from './src/components/SidebarPortal';
export * from './src/components/AppRouteNotFound';
export * from './src/components/ExternalRedirect';

// Contexts
export * from './src/context/MutationErrorContext';

// Routing
export * from './src/routes/defaultRouteConfig';

// Hooks
export * from './src/hooks/useLayoutSize';
export * from './src/hooks/useAddBreadcrumbUrlTranslation';
export * from './src/hooks/useUnitsPreference';

// Utilities
export * from './src/utils/languageUtils';

// User profile settings
export * from './src/components/userProfileSettings/types';
export * from './src/components/userProfileSettings/PermissionsDisplay';

// Common Navigation components for brewing-recipes and supply-data-management-portal (grouped for clarity)
export * from './src/components/navigation/NavigationLink';
export * from './src/components/navigation/SidebarWithNavigation';
export * from './src/components/navigation/navigation.types';
export * from './src/components/navigation/PlaceholderScreen';

// Links
export * from './src/components/constants';
